import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.to-string-tag.js";
import "core-js/modules/es.reflect.construct.js";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["children"],
  _excluded2 = ["container"],
  _excluded3 = ["container"],
  _excluded4 = ["to", "from"],
  _excluded5 = ["root", "once", "amount"],
  _excluded6 = ["children"],
  _excluded7 = ["items", "children"],
  _excluded8 = ["items", "children"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import "regenerator-runtime/runtime.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.object.is-frozen.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/es.array.reduce.js";
// src/hooks/useChain.ts
import { each, useIsomorphicLayoutEffect } from "@react-spring/shared";

// src/helpers.ts
import { is, toArray, eachProp, getFluidValue, isAnimatedString, Globals as G } from "@react-spring/shared";
function callProp(value) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return is.fun(value) ? value.apply(void 0, args) : value;
}
var matchProp = function matchProp(value, key) {
  return value === true || !!(key && value && (is.fun(value) ? value(key) : toArray(value).includes(key)));
};
var resolveProp = function resolveProp(prop, key) {
  return is.obj(prop) ? key && prop[key] : prop;
};
var getDefaultProp = function getDefaultProp(props, key) {
  return props.default === true ? props[key] : props.default ? props.default[key] : void 0;
};
var noopTransform = function noopTransform(value) {
  return value;
};
var getDefaultProps = function getDefaultProps(props) {
  var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noopTransform;
  var keys = DEFAULT_PROPS;
  if (props.default && props.default !== true) {
    props = props.default;
    keys = Object.keys(props);
  }
  var defaults2 = {};
  var _iterator = _createForOfIteratorHelper(keys),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      var value = transform(props[key], key);
      if (!is.und(value)) {
        defaults2[key] = value;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return defaults2;
};
var DEFAULT_PROPS = ["config", "onProps", "onStart", "onChange", "onPause", "onResume", "onRest"];
var RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
function getForwardProps(props) {
  var forward = {};
  var count = 0;
  eachProp(props, function (value, prop) {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });
  if (count) {
    return forward;
  }
}
function inferTo(props) {
  var to2 = getForwardProps(props);
  if (to2) {
    var out = {
      to: to2
    };
    eachProp(props, function (val, key) {
      return key in to2 || (out[key] = val);
    });
    return out;
  }
  return _objectSpread({}, props);
}
function computeGoal(value) {
  value = getFluidValue(value);
  return is.arr(value) ? value.map(computeGoal) : isAnimatedString(value) ? G.createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}
function hasProps(props) {
  for (var _ in props) return true;
  return false;
}
function isAsyncTo(to2) {
  return is.fun(to2) || is.arr(to2) && is.obj(to2[0]);
}
function detachRefs(ctrl, ref) {
  var _ctrl$ref;
  (_ctrl$ref = ctrl.ref) === null || _ctrl$ref === void 0 ? void 0 : _ctrl$ref.delete(ctrl);
  ref === null || ref === void 0 ? void 0 : ref.delete(ctrl);
}
function replaceRef(ctrl, ref) {
  if (ref && ctrl.ref !== ref) {
    var _ctrl$ref2;
    (_ctrl$ref2 = ctrl.ref) === null || _ctrl$ref2 === void 0 ? void 0 : _ctrl$ref2.delete(ctrl);
    ref.add(ctrl);
    ctrl.ref = ref;
  }
}

// src/hooks/useChain.ts
function useChain(refs, timeSteps) {
  var timeFrame = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e3;
  useIsomorphicLayoutEffect(function () {
    if (timeSteps) {
      var prevDelay = 0;
      each(refs, function (ref, i) {
        var controllers = ref.current;
        if (controllers.length) {
          var delay = timeFrame * timeSteps[i];
          if (isNaN(delay)) delay = prevDelay;else prevDelay = delay;
          each(controllers, function (ctrl) {
            each(ctrl.queue, function (props) {
              var memoizedDelayProp = props.delay;
              props.delay = function (key) {
                return delay + callProp(memoizedDelayProp || 0, key);
              };
            });
          });
          ref.start();
        }
      });
    } else {
      var p = Promise.resolve();
      each(refs, function (ref) {
        var controllers = ref.current;
        if (controllers.length) {
          var queues = controllers.map(function (ctrl) {
            var q = ctrl.queue;
            ctrl.queue = [];
            return q;
          });
          p = p.then(function () {
            each(controllers, function (ctrl, i) {
              return each(queues[i] || [], function (update2) {
                return ctrl.queue.push(update2);
              });
            });
            return Promise.all(ref.start());
          });
        }
      });
    }
  });
}

// src/hooks/useSpring.ts
import { is as is9 } from "@react-spring/shared";

// src/hooks/useSprings.ts
import { useContext as useContext2, useMemo, useRef } from "react";
import { is as is8, each as each5, usePrev, useOnce, useForceUpdate, useIsomorphicLayoutEffect as useIsomorphicLayoutEffect2 } from "@react-spring/shared";

// src/SpringValue.ts
import { is as is5, raf as raf3, each as each2, isEqual, toArray as toArray2, eachProp as eachProp3, frameLoop as frameLoop2, flushCalls, getFluidValue as getFluidValue2, isAnimatedString as isAnimatedString2, Globals as G5, callFluidObservers as callFluidObservers2, hasFluidValue, addFluidObserver, removeFluidObserver, getFluidObservers } from "@react-spring/shared";
import { AnimatedValue, AnimatedString, getPayload, getAnimated as getAnimated2, setAnimated, getAnimatedType } from "@react-spring/animated";

// src/AnimationConfig.ts
import { is as is2, easings } from "@react-spring/shared";

// src/constants.ts
var config = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};

// src/AnimationConfig.ts
var defaults = _objectSpread(_objectSpread({}, config.default), {}, {
  mass: 1,
  damping: 1,
  easing: easings.linear,
  clamp: false
});
var AnimationConfig = /*#__PURE__*/_createClass(function AnimationConfig() {
  _classCallCheck(this, AnimationConfig);
  /**
   * The initial velocity of one or more values.
   *
   * @default 0
   */
  this.velocity = 0;
  Object.assign(this, defaults);
});
function mergeConfig(config2, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = _objectSpread({}, defaultConfig);
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = _objectSpread(_objectSpread({}, defaultConfig), newConfig);
  }
  sanitizeConfig(config2, newConfig);
  Object.assign(config2, newConfig);
  for (var key in defaults) {
    if (config2[key] == null) {
      config2[key] = defaults[key];
    }
  }
  var frequency = config2.frequency,
    damping = config2.damping;
  var mass = config2.mass;
  if (!is2.und(frequency)) {
    if (frequency < 0.01) frequency = 0.01;
    if (damping < 0) damping = 0;
    config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config2.friction = 4 * Math.PI * damping * mass / frequency;
  }
  return config2;
}
function sanitizeConfig(config2, props) {
  if (!is2.und(props.decay)) {
    config2.duration = void 0;
  } else {
    var isTensionConfig = !is2.und(props.tension) || !is2.und(props.friction);
    if (isTensionConfig || !is2.und(props.frequency) || !is2.und(props.damping) || !is2.und(props.mass)) {
      config2.duration = void 0;
      config2.decay = void 0;
    }
    if (isTensionConfig) {
      config2.frequency = void 0;
    }
  }
}

// src/Animation.ts
var emptyArray = [];
var Animation = /*#__PURE__*/_createClass(function Animation() {
  _classCallCheck(this, Animation);
  this.changed = false;
  this.values = emptyArray;
  this.toValues = null;
  this.fromValues = emptyArray;
  this.config = new AnimationConfig();
  this.immediate = false;
});

// src/scheduleProps.ts
import { is as is3, raf, Globals as G2 } from "@react-spring/shared";
function scheduleProps(callId, _ref) {
  var key = _ref.key,
    props = _ref.props,
    defaultProps = _ref.defaultProps,
    state = _ref.state,
    actions = _ref.actions;
  return new Promise(function (resolve, reject) {
    var _props$cancel;
    var delay;
    var timeout;
    var cancel = matchProp((_props$cancel = props.cancel) !== null && _props$cancel !== void 0 ? _props$cancel : defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.cancel, key);
    if (cancel) {
      onStart();
    } else {
      if (!is3.und(props.pause)) {
        state.paused = matchProp(props.pause, key);
      }
      var pause = defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.pause;
      if (pause !== true) {
        pause = state.paused || matchProp(pause, key);
      }
      delay = callProp(props.delay || 0, key);
      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }
    function onPause() {
      state.resumeQueue.add(onResume);
      state.timeouts.delete(timeout);
      timeout.cancel();
      delay = timeout.time - raf.now();
    }
    function onResume() {
      if (delay > 0 && !G2.skipAnimation) {
        state.delayed = true;
        timeout = raf.setTimeout(onStart, delay);
        state.pauseQueue.add(onPause);
        state.timeouts.add(timeout);
      } else {
        onStart();
      }
    }
    function onStart() {
      if (state.delayed) {
        state.delayed = false;
      }
      state.pauseQueue.delete(onPause);
      state.timeouts.delete(timeout);
      if (callId <= (state.cancelId || 0)) {
        cancel = true;
      }
      try {
        actions.start(_objectSpread(_objectSpread({}, props), {}, {
          callId: callId,
          cancel: cancel
        }), resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
}

// src/runAsync.ts
import { is as is4, raf as raf2, flush, eachProp as eachProp2, Globals as G3 } from "@react-spring/shared";

// src/AnimationResult.ts
var getCombinedResult = function getCombinedResult(target, results) {
  return results.length == 1 ? results[0] : results.some(function (result) {
    return result.cancelled;
  }) ? getCancelledResult(target.get()) : results.every(function (result) {
    return result.noop;
  }) ? getNoopResult(target.get()) : getFinishedResult(target.get(), results.every(function (result) {
    return result.finished;
  }));
};
var getNoopResult = function getNoopResult(value) {
  return {
    value: value,
    noop: true,
    finished: true,
    cancelled: false
  };
};
var getFinishedResult = function getFinishedResult(value, finished) {
  var cancelled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    value: value,
    finished: finished,
    cancelled: cancelled
  };
};
var getCancelledResult = function getCancelledResult(value) {
  return {
    value: value,
    cancelled: true,
    finished: false
  };
};

// src/runAsync.ts
function runAsync(to2, props, state, target) {
  var callId = props.callId,
    parentId = props.parentId,
    onRest = props.onRest;
  var prevTo = state.asyncTo,
    prevPromise = state.promise;
  if (!parentId && to2 === prevTo && !props.reset) {
    return prevPromise;
  }
  return state.promise = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var defaultProps, preventBail, bail, bailPromise, bailIfEnded, animate, result, animating;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          state.asyncId = callId;
          state.asyncTo = to2;
          defaultProps = getDefaultProps(props, function (value, key) {
            return (
              // The `onRest` prop is only called when the `runAsync` promise is resolved.
              key === "onRest" ? void 0 : value
            );
          });
          bailPromise = new Promise(function (resolve, reject) {
            return preventBail = resolve, bail = reject;
          });
          bailIfEnded = function bailIfEnded(bailSignal) {
            var bailResult =
            // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && getCancelledResult(target) ||
            // The async `to` prop was replaced.
            callId !== state.asyncId && getFinishedResult(target, false);
            if (bailResult) {
              bailSignal.result = bailResult;
              bail(bailSignal);
              throw bailSignal;
            }
          };
          animate = function animate(arg1, arg2) {
            var bailSignal = new BailSignal();
            var skipAnimationSignal = new SkipAnimationSignal();
            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
              var props2, result2;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!G3.skipAnimation) {
                      _context.next = 5;
                      break;
                    }
                    stopAsync(state);
                    skipAnimationSignal.result = getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                  case 5:
                    bailIfEnded(bailSignal);
                    props2 = is4.obj(arg1) ? _objectSpread({}, arg1) : _objectSpread(_objectSpread({}, arg2), {}, {
                      to: arg1
                    });
                    props2.parentId = callId;
                    eachProp2(defaultProps, function (value, key) {
                      if (is4.und(props2[key])) {
                        props2[key] = value;
                      }
                    });
                    _context.next = 11;
                    return target.start(props2);
                  case 11:
                    result2 = _context.sent;
                    bailIfEnded(bailSignal);
                    if (!state.paused) {
                      _context.next = 16;
                      break;
                    }
                    _context.next = 16;
                    return new Promise(function (resume) {
                      state.resumeQueue.add(resume);
                    });
                  case 16:
                    return _context.abrupt("return", result2);
                  case 17:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }))();
          };
          if (!G3.skipAnimation) {
            _context3.next = 9;
            break;
          }
          stopAsync(state);
          return _context3.abrupt("return", getFinishedResult(target, false));
        case 9:
          _context3.prev = 9;
          if (is4.arr(to2)) {
            animating = function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(queue) {
                var _iterator2, _step2, props2;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _iterator2 = _createForOfIteratorHelper(queue);
                      _context2.prev = 1;
                      _iterator2.s();
                    case 3:
                      if ((_step2 = _iterator2.n()).done) {
                        _context2.next = 9;
                        break;
                      }
                      props2 = _step2.value;
                      _context2.next = 7;
                      return animate(props2);
                    case 7:
                      _context2.next = 3;
                      break;
                    case 9:
                      _context2.next = 14;
                      break;
                    case 11:
                      _context2.prev = 11;
                      _context2.t0 = _context2["catch"](1);
                      _iterator2.e(_context2.t0);
                    case 14:
                      _context2.prev = 14;
                      _iterator2.f();
                      return _context2.finish(14);
                    case 17:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, null, [[1, 11, 14, 17]]);
              }));
              return function (_x) {
                return _ref4.apply(this, arguments);
              };
            }()(to2);
          } else {
            animating = Promise.resolve(to2(animate, target.stop.bind(target)));
          }
          _context3.next = 13;
          return Promise.all([animating.then(preventBail), bailPromise]);
        case 13:
          result = getFinishedResult(target.get(), true, false);
          _context3.next = 27;
          break;
        case 16:
          _context3.prev = 16;
          _context3.t0 = _context3["catch"](9);
          if (!(_context3.t0 instanceof BailSignal)) {
            _context3.next = 22;
            break;
          }
          result = _context3.t0.result;
          _context3.next = 27;
          break;
        case 22:
          if (!(_context3.t0 instanceof SkipAnimationSignal)) {
            _context3.next = 26;
            break;
          }
          result = _context3.t0.result;
          _context3.next = 27;
          break;
        case 26:
          throw _context3.t0;
        case 27:
          _context3.prev = 27;
          if (callId == state.asyncId) {
            state.asyncId = parentId;
            state.asyncTo = parentId ? prevTo : void 0;
            state.promise = parentId ? prevPromise : void 0;
          }
          return _context3.finish(27);
        case 30:
          if (is4.fun(onRest)) {
            raf2.batchedUpdates(function () {
              onRest(result, target, target.item);
            });
          }
          return _context3.abrupt("return", result);
        case 32:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[9, 16, 27, 30]]);
  }))();
}
function stopAsync(state, cancelId) {
  flush(state.timeouts, function (t) {
    return t.cancel();
  });
  state.pauseQueue.clear();
  state.resumeQueue.clear();
  state.asyncId = state.asyncTo = state.promise = void 0;
  if (cancelId) state.cancelId = cancelId;
}
var BailSignal = /*#__PURE__*/function (_Error) {
  _inherits(BailSignal, _Error);
  var _super = _createSuper(BailSignal);
  function BailSignal() {
    _classCallCheck(this, BailSignal);
    return _super.call(this, "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
  }
  return _createClass(BailSignal);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var SkipAnimationSignal = /*#__PURE__*/function (_Error2) {
  _inherits(SkipAnimationSignal, _Error2);
  var _super2 = _createSuper(SkipAnimationSignal);
  function SkipAnimationSignal() {
    _classCallCheck(this, SkipAnimationSignal);
    return _super2.call(this, "SkipAnimationSignal");
  }
  return _createClass(SkipAnimationSignal);
}( /*#__PURE__*/_wrapNativeSuper(Error));

// src/FrameValue.ts
import { deprecateInterpolate, frameLoop, FluidValue as FluidValue2, Globals as G4, callFluidObservers } from "@react-spring/shared";
import { getAnimated } from "@react-spring/animated";
var isFrameValue = function isFrameValue(value) {
  return value instanceof FrameValue;
};
var nextId = 1;
var FrameValue = /*#__PURE__*/function (_FluidValue) {
  _inherits(FrameValue, _FluidValue);
  var _super3 = _createSuper(FrameValue);
  function FrameValue() {
    var _this;
    _classCallCheck(this, FrameValue);
    _this = _super3.apply(this, arguments);
    _this.id = nextId++;
    _this._priority = 0;
    return _this;
  }
  _createClass(FrameValue, [{
    key: "priority",
    get: function get() {
      return this._priority;
    },
    set: function set(priority) {
      if (this._priority != priority) {
        this._priority = priority;
        this._onPriorityChange(priority);
      }
    }
    /** Get the current value */
  }, {
    key: "get",
    value: function get() {
      var node = getAnimated(this);
      return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */
  }, {
    key: "to",
    value: function to() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return G4.to(this, args);
    }
    /** @deprecated Use the `to` method instead. */
  }, {
    key: "interpolate",
    value: function interpolate() {
      deprecateInterpolate();
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return G4.to(this, args);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.get();
    }
  }, {
    key: "observerAdded",
    value: function observerAdded(count) {
      if (count == 1) this._attach();
    }
  }, {
    key: "observerRemoved",
    value: function observerRemoved(count) {
      if (count == 0) this._detach();
    }
    /** Called when the first child is added. */
  }, {
    key: "_attach",
    value: function _attach() {}
    /** Called when the last child is removed. */
  }, {
    key: "_detach",
    value: function _detach() {}
    /** Tell our children about our new value */
  }, {
    key: "_onChange",
    value: function _onChange(value) {
      var idle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      callFluidObservers(this, {
        type: "change",
        parent: this,
        value: value,
        idle: idle
      });
    }
    /** Tell our children about our new priority */
  }, {
    key: "_onPriorityChange",
    value: function _onPriorityChange(priority) {
      if (!this.idle) {
        frameLoop.sort(this);
      }
      callFluidObservers(this, {
        type: "priority",
        parent: this,
        priority: priority
      });
    }
  }]);
  return FrameValue;
}(FluidValue2);

// src/SpringPhase.ts
var $P = Symbol.for("SpringPhase");
var HAS_ANIMATED = 1;
var IS_ANIMATING = 2;
var IS_PAUSED = 4;
var hasAnimated = function hasAnimated(target) {
  return (target[$P] & HAS_ANIMATED) > 0;
};
var isAnimating = function isAnimating(target) {
  return (target[$P] & IS_ANIMATING) > 0;
};
var isPaused = function isPaused(target) {
  return (target[$P] & IS_PAUSED) > 0;
};
var setActiveBit = function setActiveBit(target, active) {
  return active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
};
var setPausedBit = function setPausedBit(target, paused) {
  return paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;
};

// src/SpringValue.ts
var SpringValue = /*#__PURE__*/function (_FrameValue) {
  _inherits(SpringValue, _FrameValue);
  var _super4 = _createSuper(SpringValue);
  function SpringValue(arg1, arg2) {
    var _this2;
    _classCallCheck(this, SpringValue);
    _this2 = _super4.call(this);
    /** The animation state */
    _this2.animation = new Animation();
    /** Some props have customizable default values */
    _this2.defaultProps = {};
    /** The state for `runAsync` calls */
    _this2._state = {
      paused: false,
      delayed: false,
      pauseQueue: /* @__PURE__ */new Set(),
      resumeQueue: /* @__PURE__ */new Set(),
      timeouts: /* @__PURE__ */new Set()
    };
    /** The promise resolvers of pending `start` calls */
    _this2._pendingCalls = /* @__PURE__ */new Set();
    /** The counter for tracking `scheduleProps` calls */
    _this2._lastCallId = 0;
    /** The last `scheduleProps` call that changed the `to` prop */
    _this2._lastToId = 0;
    _this2._memoizedDuration = 0;
    if (!is5.und(arg1) || !is5.und(arg2)) {
      var props = is5.obj(arg1) ? _objectSpread({}, arg1) : _objectSpread(_objectSpread({}, arg2), {}, {
        from: arg1
      });
      if (is5.und(props.default)) {
        props.default = true;
      }
      _this2.start(props);
    }
    return _this2;
  }
  /** Equals true when not advancing on each frame. */
  _createClass(SpringValue, [{
    key: "idle",
    get: function get() {
      return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
    }
  }, {
    key: "goal",
    get: function get() {
      return getFluidValue2(this.animation.to);
    }
  }, {
    key: "velocity",
    get: function get() {
      var node = getAnimated2(this);
      return node instanceof AnimatedValue ? node.lastVelocity || 0 : node.getPayload().map(function (node2) {
        return node2.lastVelocity || 0;
      });
    }
    /**
     * When true, this value has been animated at least once.
     */
  }, {
    key: "hasAnimated",
    get: function get() {
      return hasAnimated(this);
    }
    /**
     * When true, this value has an unfinished animation,
     * which is either active or paused.
     */
  }, {
    key: "isAnimating",
    get: function get() {
      return isAnimating(this);
    }
    /**
     * When true, all current and future animations are paused.
     */
  }, {
    key: "isPaused",
    get: function get() {
      return isPaused(this);
    }
    /**
     *
     *
     */
  }, {
    key: "isDelayed",
    get: function get() {
      return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */
  }, {
    key: "advance",
    value: function advance(dt) {
      var _this3 = this;
      var idle = true;
      var changed = false;
      var anim = this.animation;
      var toValues = anim.toValues;
      var config2 = anim.config;
      var payload = getPayload(anim.to);
      if (!payload && hasFluidValue(anim.to)) {
        toValues = toArray2(getFluidValue2(anim.to));
      }
      anim.values.forEach(function (node2, i) {
        if (node2.done) return;
        var to2 =
        // Animated strings always go from 0 to 1.
        node2.constructor == AnimatedString ? 1 : payload ? payload[i].lastPosition : toValues[i];
        var finished = anim.immediate;
        var position = to2;
        if (!finished) {
          position = node2.lastPosition;
          if (config2.tension <= 0) {
            node2.done = true;
            return;
          }
          var elapsed = node2.elapsedTime += dt;
          var from = anim.fromValues[i];
          var v0 = node2.v0 != null ? node2.v0 : node2.v0 = is5.arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
          var velocity;
          var precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
          if (!is5.und(config2.duration)) {
            var p = 1;
            if (config2.duration > 0) {
              if (_this3._memoizedDuration !== config2.duration) {
                _this3._memoizedDuration = config2.duration;
                if (node2.durationProgress > 0) {
                  node2.elapsedTime = config2.duration * node2.durationProgress;
                  elapsed = node2.elapsedTime += dt;
                }
              }
              p = (config2.progress || 0) + elapsed / _this3._memoizedDuration;
              p = p > 1 ? 1 : p < 0 ? 0 : p;
              node2.durationProgress = p;
            }
            position = from + config2.easing(p) * (to2 - from);
            velocity = (position - node2.lastPosition) / dt;
            finished = p == 1;
          } else if (config2.decay) {
            var decay = config2.decay === true ? 0.998 : config2.decay;
            var e = Math.exp(-(1 - decay) * elapsed);
            position = from + v0 / (1 - decay) * (1 - e);
            finished = Math.abs(node2.lastPosition - position) <= precision;
            velocity = v0 * e;
          } else {
            velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
            var restVelocity = config2.restVelocity || precision / 10;
            var bounceFactor = config2.clamp ? 0 : config2.bounce;
            var canBounce = !is5.und(bounceFactor);
            var isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
            var isMoving;
            var isBouncing = false;
            var step = 1;
            var numSteps = Math.ceil(dt / step);
            for (var n = 0; n < numSteps; ++n) {
              isMoving = Math.abs(velocity) > restVelocity;
              if (!isMoving) {
                finished = Math.abs(to2 - position) <= precision;
                if (finished) {
                  break;
                }
              }
              if (canBounce) {
                isBouncing = position == to2 || position > to2 == isGrowing;
                if (isBouncing) {
                  velocity = -velocity * bounceFactor;
                  position = to2;
                }
              }
              var springForce = -config2.tension * 1e-6 * (position - to2);
              var dampingForce = -config2.friction * 1e-3 * velocity;
              var acceleration = (springForce + dampingForce) / config2.mass;
              velocity = velocity + acceleration * step;
              position = position + velocity * step;
            }
          }
          node2.lastVelocity = velocity;
          if (Number.isNaN(position)) {
            console.warn("Got NaN while animating:", _this3);
            finished = true;
          }
        }
        if (payload && !payload[i].done) {
          finished = false;
        }
        if (finished) {
          node2.done = true;
        } else {
          idle = false;
        }
        if (node2.setValue(position, config2.round)) {
          changed = true;
        }
      });
      var node = getAnimated2(this);
      var currVal = node.getValue();
      if (idle) {
        var finalVal = getFluidValue2(anim.to);
        if ((currVal !== finalVal || changed) && !config2.decay) {
          node.setValue(finalVal);
          this._onChange(finalVal);
        } else if (changed && config2.decay) {
          this._onChange(currVal);
        }
        this._stop();
      } else if (changed) {
        this._onChange(currVal);
      }
    }
    /** Set the current value, while stopping the current animation */
  }, {
    key: "set",
    value: function set(value) {
      var _this4 = this;
      raf3.batchedUpdates(function () {
        _this4._stop();
        _this4._focus(value);
        _this4._set(value);
      });
      return this;
    }
    /**
     * Freeze the active animation in time, as well as any updates merged
     * before `resume` is called.
     */
  }, {
    key: "pause",
    value: function pause() {
      this._update({
        pause: true
      });
    }
    /** Resume the animation if paused. */
  }, {
    key: "resume",
    value: function resume() {
      this._update({
        pause: false
      });
    }
    /** Skip to the end of the current animation. */
  }, {
    key: "finish",
    value: function finish() {
      var _this5 = this;
      if (isAnimating(this)) {
        var _this$animation = this.animation,
          to2 = _this$animation.to,
          config2 = _this$animation.config;
        raf3.batchedUpdates(function () {
          _this5._onStart();
          if (!config2.decay) {
            _this5._set(to2, false);
          }
          _this5._stop();
        });
      }
      return this;
    }
    /** Push props into the pending queue. */
  }, {
    key: "update",
    value: function update(props) {
      var queue = this.queue || (this.queue = []);
      queue.push(props);
      return this;
    }
  }, {
    key: "start",
    value: function start(to2, arg2) {
      var _this6 = this;
      var queue;
      if (!is5.und(to2)) {
        queue = [is5.obj(to2) ? to2 : _objectSpread(_objectSpread({}, arg2), {}, {
          to: to2
        })];
      } else {
        queue = this.queue || [];
        this.queue = [];
      }
      return Promise.all(queue.map(function (props) {
        var up = _this6._update(props);
        return up;
      })).then(function (results) {
        return getCombinedResult(_this6, results);
      });
    }
    /**
     * Stop the current animation, and cancel any delayed updates.
     *
     * Pass `true` to call `onRest` with `cancelled: true`.
     */
  }, {
    key: "stop",
    value: function stop(cancel) {
      var _this7 = this;
      var to2 = this.animation.to;
      this._focus(this.get());
      stopAsync(this._state, cancel && this._lastCallId);
      raf3.batchedUpdates(function () {
        return _this7._stop(to2, cancel);
      });
      return this;
    }
    /** Restart the animation. */
  }, {
    key: "reset",
    value: function reset() {
      this._update({
        reset: true
      });
    }
    /** @internal */
  }, {
    key: "eventObserved",
    value: function eventObserved(event) {
      if (event.type == "change") {
        this._start();
      } else if (event.type == "priority") {
        this.priority = event.priority + 1;
      }
    }
    /**
     * Parse the `to` and `from` range from the given `props` object.
     *
     * This also ensures the initial value is available to animated components
     * during the render phase.
     */
  }, {
    key: "_prepareNode",
    value: function _prepareNode(props) {
      var key = this.key || "";
      var to2 = props.to,
        from = props.from;
      to2 = is5.obj(to2) ? to2[key] : to2;
      if (to2 == null || isAsyncTo(to2)) {
        to2 = void 0;
      }
      from = is5.obj(from) ? from[key] : from;
      if (from == null) {
        from = void 0;
      }
      var range = {
        to: to2,
        from: from
      };
      if (!hasAnimated(this)) {
        if (props.reverse) {
          var _ref5 = [from, to2];
          to2 = _ref5[0];
          from = _ref5[1];
        }
        from = getFluidValue2(from);
        if (!is5.und(from)) {
          this._set(from);
        } else if (!getAnimated2(this)) {
          this._set(to2);
        }
      }
      return range;
    }
    /** Every update is processed by this method before merging. */
  }, {
    key: "_update",
    value: function _update(_ref6, isLoop) {
      var _this8 = this;
      var props = Object.assign({}, (_objectDestructuringEmpty(_ref6), _ref6));
      var key = this.key,
        defaultProps = this.defaultProps;
      if (props.default) Object.assign(defaultProps, getDefaultProps(props, function (value, prop) {
        return /^on/.test(prop) ? resolveProp(value, key) : value;
      }));
      mergeActiveFn(this, props, "onProps");
      sendEvent(this, "onProps", props, this);
      var range = this._prepareNode(props);
      if (Object.isFrozen(this)) {
        throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
      }
      var state = this._state;
      return scheduleProps(++this._lastCallId, {
        key: key,
        props: props,
        defaultProps: defaultProps,
        state: state,
        actions: {
          pause: function pause() {
            if (!isPaused(_this8)) {
              setPausedBit(_this8, true);
              flushCalls(state.pauseQueue);
              sendEvent(_this8, "onPause", getFinishedResult(_this8, checkFinished(_this8, _this8.animation.to)), _this8);
            }
          },
          resume: function resume() {
            if (isPaused(_this8)) {
              setPausedBit(_this8, false);
              if (isAnimating(_this8)) {
                _this8._resume();
              }
              flushCalls(state.resumeQueue);
              sendEvent(_this8, "onResume", getFinishedResult(_this8, checkFinished(_this8, _this8.animation.to)), _this8);
            }
          },
          start: this._merge.bind(this, range)
        }
      }).then(function (result) {
        if (props.loop && result.finished && !(isLoop && result.noop)) {
          var nextProps = createLoopUpdate(props);
          if (nextProps) {
            return _this8._update(nextProps, true);
          }
        }
        return result;
      });
    }
    /** Merge props into the current animation */
  }, {
    key: "_merge",
    value: function _merge(range, props, resolve) {
      var _this9 = this;
      if (props.cancel) {
        this.stop(true);
        return resolve(getCancelledResult(this));
      }
      var hasToProp = !is5.und(range.to);
      var hasFromProp = !is5.und(range.from);
      if (hasToProp || hasFromProp) {
        if (props.callId > this._lastToId) {
          this._lastToId = props.callId;
        } else {
          return resolve(getCancelledResult(this));
        }
      }
      var key = this.key,
        defaultProps = this.defaultProps,
        anim = this.animation;
      var prevTo = anim.to,
        prevFrom = anim.from;
      var _range$to = range.to,
        to2 = _range$to === void 0 ? prevTo : _range$to,
        _range$from = range.from,
        from = _range$from === void 0 ? prevFrom : _range$from;
      if (hasFromProp && !hasToProp && (!props.default || is5.und(to2))) {
        to2 = from;
      }
      if (props.reverse) {
        var _ref7 = [from, to2];
        to2 = _ref7[0];
        from = _ref7[1];
      }
      var hasFromChanged = !isEqual(from, prevFrom);
      if (hasFromChanged) {
        anim.from = from;
      }
      from = getFluidValue2(from);
      var hasToChanged = !isEqual(to2, prevTo);
      if (hasToChanged) {
        this._focus(to2);
      }
      var hasAsyncTo = isAsyncTo(props.to);
      var config2 = anim.config;
      var decay = config2.decay,
        velocity = config2.velocity;
      if (hasToProp || hasFromProp) {
        config2.velocity = 0;
      }
      if (props.config && !hasAsyncTo) {
        mergeConfig(config2, callProp(props.config, key),
        // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
      }
      var node = getAnimated2(this);
      if (!node || is5.und(to2)) {
        return resolve(getFinishedResult(this, true));
      }
      var reset =
      // When `reset` is undefined, the `from` prop implies `reset: true`,
      // except for declarative updates. When `reset` is defined, there
      // must exist a value to animate from.
      is5.und(props.reset) ? hasFromProp && !props.default : !is5.und(from) && matchProp(props.reset, key);
      var value = reset ? from : this.get();
      var goal = computeGoal(to2);
      var isAnimatable = is5.num(goal) || is5.arr(goal) || isAnimatedString2(goal);
      var immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));
      if (hasToChanged) {
        var nodeType = getAnimatedType(to2);
        if (nodeType !== node.constructor) {
          if (immediate) {
            node = this._set(goal);
          } else throw Error("Cannot animate between ".concat(node.constructor.name, " and ").concat(nodeType.name, ", as the \"to\" prop suggests"));
        }
      }
      var goalType = node.constructor;
      var started = hasFluidValue(to2);
      var finished = false;
      if (!started) {
        var hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;
        if (hasToChanged || hasValueChanged) {
          finished = isEqual(computeGoal(value), goal);
          started = !finished;
        }
        if (!isEqual(anim.immediate, immediate) && !immediate || !isEqual(config2.decay, decay) || !isEqual(config2.velocity, velocity)) {
          started = true;
        }
      }
      if (finished && isAnimating(this)) {
        if (anim.changed && !reset) {
          started = true;
        } else if (!started) {
          this._stop(prevTo);
        }
      }
      if (!hasAsyncTo) {
        if (started || hasFluidValue(prevTo)) {
          anim.values = node.getPayload();
          anim.toValues = hasFluidValue(to2) ? null : goalType == AnimatedString ? [1] : toArray2(goal);
        }
        if (anim.immediate != immediate) {
          anim.immediate = immediate;
          if (!immediate && !reset) {
            this._set(prevTo);
          }
        }
        if (started) {
          var onRest = anim.onRest;
          each2(ACTIVE_EVENTS, function (type) {
            return mergeActiveFn(_this9, props, type);
          });
          var result = getFinishedResult(this, checkFinished(this, prevTo));
          flushCalls(this._pendingCalls, result);
          this._pendingCalls.add(resolve);
          if (anim.changed) raf3.batchedUpdates(function () {
            anim.changed = !reset;
            onRest === null || onRest === void 0 ? void 0 : onRest(result, _this9);
            if (reset) {
              callProp(defaultProps.onRest, result);
            } else {
              var _anim$onStart;
              (_anim$onStart = anim.onStart) === null || _anim$onStart === void 0 ? void 0 : _anim$onStart.call(anim, result, _this9);
            }
          });
        }
      }
      if (reset) {
        this._set(value);
      }
      if (hasAsyncTo) {
        resolve(runAsync(props.to, props, this._state, this));
      } else if (started) {
        this._start();
      } else if (isAnimating(this) && !hasToChanged) {
        this._pendingCalls.add(resolve);
      } else {
        resolve(getNoopResult(value));
      }
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */
  }, {
    key: "_focus",
    value: function _focus(value) {
      var anim = this.animation;
      if (value !== anim.to) {
        if (getFluidObservers(this)) {
          this._detach();
        }
        anim.to = value;
        if (getFluidObservers(this)) {
          this._attach();
        }
      }
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var priority = 0;
      var to2 = this.animation.to;
      if (hasFluidValue(to2)) {
        addFluidObserver(to2, this);
        if (isFrameValue(to2)) {
          priority = to2.priority + 1;
        }
      }
      this.priority = priority;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      var to2 = this.animation.to;
      if (hasFluidValue(to2)) {
        removeFluidObserver(to2, this);
      }
    }
    /**
     * Update the current value from outside the frameloop,
     * and return the `Animated` node.
     */
  }, {
    key: "_set",
    value: function _set(arg) {
      var _this10 = this;
      var idle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var value = getFluidValue2(arg);
      if (!is5.und(value)) {
        var oldNode = getAnimated2(this);
        if (!oldNode || !isEqual(value, oldNode.getValue())) {
          var nodeType = getAnimatedType(value);
          if (!oldNode || oldNode.constructor != nodeType) {
            setAnimated(this, nodeType.create(value));
          } else {
            oldNode.setValue(value);
          }
          if (oldNode) {
            raf3.batchedUpdates(function () {
              _this10._onChange(value, idle);
            });
          }
        }
      }
      return getAnimated2(this);
    }
  }, {
    key: "_onStart",
    value: function _onStart() {
      var anim = this.animation;
      if (!anim.changed) {
        anim.changed = true;
        sendEvent(this, "onStart", getFinishedResult(this, checkFinished(this, anim.to)), this);
      }
    }
  }, {
    key: "_onChange",
    value: function _onChange(value, idle) {
      if (!idle) {
        this._onStart();
        callProp(this.animation.onChange, value, this);
      }
      callProp(this.defaultProps.onChange, value, this);
      _get(_getPrototypeOf(SpringValue.prototype), "_onChange", this).call(this, value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
  }, {
    key: "_start",
    value: function _start() {
      var anim = this.animation;
      getAnimated2(this).reset(getFluidValue2(anim.to));
      if (!anim.immediate) {
        anim.fromValues = anim.values.map(function (node) {
          return node.lastPosition;
        });
      }
      if (!isAnimating(this)) {
        setActiveBit(this, true);
        if (!isPaused(this)) {
          this._resume();
        }
      }
    }
  }, {
    key: "_resume",
    value: function _resume() {
      if (G5.skipAnimation) {
        this.finish();
      } else {
        frameLoop2.start(this);
      }
    }
    /**
     * Exit the frameloop and notify `onRest` listeners.
     *
     * Always wrap `_stop` calls with `batchedUpdates`.
     */
  }, {
    key: "_stop",
    value: function _stop(goal, cancel) {
      if (isAnimating(this)) {
        setActiveBit(this, false);
        var anim = this.animation;
        each2(anim.values, function (node) {
          node.done = true;
        });
        if (anim.toValues) {
          anim.onChange = anim.onPause = anim.onResume = void 0;
        }
        callFluidObservers2(this, {
          type: "idle",
          parent: this
        });
        var result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal !== null && goal !== void 0 ? goal : anim.to));
        flushCalls(this._pendingCalls, result);
        if (anim.changed) {
          anim.changed = false;
          sendEvent(this, "onRest", result, this);
        }
      }
    }
  }]);
  return SpringValue;
}(FrameValue);
function checkFinished(target, to2) {
  var goal = computeGoal(to2);
  var value = computeGoal(target.get());
  return isEqual(value, goal);
}
function createLoopUpdate(props) {
  var loop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.loop;
  var to2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : props.to;
  var loopRet = callProp(loop);
  if (loopRet) {
    var overrides = loopRet !== true && inferTo(loopRet);
    var reverse = (overrides || props).reverse;
    var reset = !overrides || overrides.reset;
    return createUpdate(_objectSpread(_objectSpread({}, props), {}, {
      loop: loop,
      // Avoid updating default props when looping.
      default: false,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !reverse || isAsyncTo(to2) ? to2 : void 0,
      // Ignore the "from" prop except on reset.
      from: reset ? props.from : void 0,
      reset: reset
    }, overrides));
  }
}
function createUpdate(props) {
  var _props = props = inferTo(props),
    to2 = _props.to,
    from = _props.from;
  var keys = /* @__PURE__ */new Set();
  if (is5.obj(to2)) findDefined(to2, keys);
  if (is5.obj(from)) findDefined(from, keys);
  props.keys = keys.size ? Array.from(keys) : null;
  return props;
}
function declareUpdate(props) {
  var update2 = createUpdate(props);
  if (is5.und(update2.default)) {
    update2.default = getDefaultProps(update2);
  }
  return update2;
}
function findDefined(values, keys) {
  eachProp3(values, function (value, key) {
    return value != null && keys.add(key);
  });
}
var ACTIVE_EVENTS = ["onStart", "onRest", "onChange", "onPause", "onResume"];
function mergeActiveFn(target, props, type) {
  target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : void 0;
}
function sendEvent(target, type) {
  var _target$animation$typ, _target$animation, _target$defaultProps$, _target$defaultProps;
  for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
    args[_key4 - 2] = arguments[_key4];
  }
  (_target$animation$typ = (_target$animation = target.animation)[type]) === null || _target$animation$typ === void 0 ? void 0 : _target$animation$typ.call.apply(_target$animation$typ, [_target$animation].concat(args));
  (_target$defaultProps$ = (_target$defaultProps = target.defaultProps)[type]) === null || _target$defaultProps$ === void 0 ? void 0 : _target$defaultProps$.call.apply(_target$defaultProps$, [_target$defaultProps].concat(args));
}

// src/Controller.ts
import { is as is6, raf as raf4, each as each3, noop, flush as flush2, toArray as toArray3, eachProp as eachProp4, flushCalls as flushCalls2, addFluidObserver as addFluidObserver2 } from "@react-spring/shared";
var BATCHED_EVENTS = ["onStart", "onChange", "onRest"];
var nextId2 = 1;
var Controller = /*#__PURE__*/function () {
  function Controller(props, flush3) {
    _classCallCheck(this, Controller);
    this.id = nextId2++;
    /** The animated values */
    this.springs = {};
    /** The queue of props passed to the `update` method. */
    this.queue = [];
    /** The counter for tracking `scheduleProps` calls */
    this._lastAsyncId = 0;
    /** The values currently being animated */
    this._active = /* @__PURE__ */new Set();
    /** The values that changed recently */
    this._changed = /* @__PURE__ */new Set();
    /** Equals false when `onStart` listeners can be called */
    this._started = false;
    /** State used by the `runAsync` function */
    this._state = {
      paused: false,
      pauseQueue: /* @__PURE__ */new Set(),
      resumeQueue: /* @__PURE__ */new Set(),
      timeouts: /* @__PURE__ */new Set()
    };
    /** The event queues that are flushed once per frame maximum */
    this._events = {
      onStart: /* @__PURE__ */new Map(),
      onChange: /* @__PURE__ */new Map(),
      onRest: /* @__PURE__ */new Map()
    };
    this._onFrame = this._onFrame.bind(this);
    if (flush3) {
      this._flush = flush3;
    }
    if (props) {
      this.start(_objectSpread({
        default: true
      }, props));
    }
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */
  _createClass(Controller, [{
    key: "idle",
    get: function get() {
      return !this._state.asyncTo && Object.values(this.springs).every(function (spring) {
        return spring.idle && !spring.isDelayed && !spring.isPaused;
      });
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(item) {
      this._item = item;
    }
    /** Get the current values of our springs */
  }, {
    key: "get",
    value: function get() {
      var values = {};
      this.each(function (spring, key) {
        return values[key] = spring.get();
      });
      return values;
    }
    /** Set the current values without animating. */
  }, {
    key: "set",
    value: function set(values) {
      for (var key in values) {
        var value = values[key];
        if (!is6.und(value)) {
          this.springs[key].set(value);
        }
      }
    }
    /** Push an update onto the queue of each value. */
  }, {
    key: "update",
    value: function update(props) {
      if (props) {
        this.queue.push(createUpdate(props));
      }
      return this;
    }
    /**
     * Start the queued animations for every spring, and resolve the returned
     * promise once all queued animations have finished or been cancelled.
     *
     * When you pass a queue (instead of nothing), that queue is used instead of
     * the queued animations added with the `update` method, which are left alone.
     */
  }, {
    key: "start",
    value: function start(props) {
      var queue = this.queue;
      if (props) {
        queue = toArray3(props).map(createUpdate);
      } else {
        this.queue = [];
      }
      if (this._flush) {
        return this._flush(this, queue);
      }
      prepareKeys(this, queue);
      return flushUpdateQueue(this, queue);
    }
    /** @internal */
  }, {
    key: "stop",
    value: function stop(arg, keys) {
      if (arg !== !!arg) {
        keys = arg;
      }
      if (keys) {
        var springs = this.springs;
        each3(toArray3(keys), function (key) {
          return springs[key].stop(!!arg);
        });
      } else {
        stopAsync(this._state, this._lastAsyncId);
        this.each(function (spring) {
          return spring.stop(!!arg);
        });
      }
      return this;
    }
    /** Freeze the active animation in time */
  }, {
    key: "pause",
    value: function pause(keys) {
      if (is6.und(keys)) {
        this.start({
          pause: true
        });
      } else {
        var springs = this.springs;
        each3(toArray3(keys), function (key) {
          return springs[key].pause();
        });
      }
      return this;
    }
    /** Resume the animation if paused. */
  }, {
    key: "resume",
    value: function resume(keys) {
      if (is6.und(keys)) {
        this.start({
          pause: false
        });
      } else {
        var springs = this.springs;
        each3(toArray3(keys), function (key) {
          return springs[key].resume();
        });
      }
      return this;
    }
    /** Call a function once per spring value */
  }, {
    key: "each",
    value: function each(iterator) {
      eachProp4(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */
  }, {
    key: "_onFrame",
    value: function _onFrame() {
      var _this11 = this;
      var _this$_events = this._events,
        onStart = _this$_events.onStart,
        onChange = _this$_events.onChange,
        onRest = _this$_events.onRest;
      var active = this._active.size > 0;
      var changed = this._changed.size > 0;
      if (active && !this._started || changed && !this._started) {
        this._started = true;
        flush2(onStart, function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
            onStart2 = _ref9[0],
            result = _ref9[1];
          result.value = _this11.get();
          onStart2(result, _this11, _this11._item);
        });
      }
      var idle = !active && this._started;
      var values = changed || idle && onRest.size ? this.get() : null;
      if (changed && onChange.size) {
        flush2(onChange, function (_ref10) {
          var _ref11 = _slicedToArray(_ref10, 2),
            onChange2 = _ref11[0],
            result = _ref11[1];
          result.value = values;
          onChange2(result, _this11, _this11._item);
        });
      }
      if (idle) {
        this._started = false;
        flush2(onRest, function (_ref12) {
          var _ref13 = _slicedToArray(_ref12, 2),
            onRest2 = _ref13[0],
            result = _ref13[1];
          result.value = values;
          onRest2(result, _this11, _this11._item);
        });
      }
    }
    /** @internal */
  }, {
    key: "eventObserved",
    value: function eventObserved(event) {
      if (event.type == "change") {
        this._changed.add(event.parent);
        if (!event.idle) {
          this._active.add(event.parent);
        }
      } else if (event.type == "idle") {
        this._active.delete(event.parent);
      } else return;
      raf4.onFrame(this._onFrame);
    }
  }]);
  return Controller;
}();
function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map(function (props) {
    return flushUpdate(ctrl, props);
  })).then(function (results) {
    return getCombinedResult(ctrl, results);
  });
}
function flushUpdate(_x2, _x3, _x4) {
  return _flushUpdate.apply(this, arguments);
}
function _flushUpdate() {
  _flushUpdate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(ctrl, props, isLoop) {
    var keys, to2, from, loop, onRest, onResolve, defaults2, asyncTo, state, promises, cancel, result, nextProps;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          keys = props.keys, to2 = props.to, from = props.from, loop = props.loop, onRest = props.onRest, onResolve = props.onResolve;
          defaults2 = is6.obj(props.default) && props.default;
          if (loop) {
            props.loop = false;
          }
          if (to2 === false) props.to = null;
          if (from === false) props.from = null;
          asyncTo = is6.arr(to2) || is6.fun(to2) ? to2 : void 0;
          if (asyncTo) {
            props.to = void 0;
            props.onRest = void 0;
            if (defaults2) {
              defaults2.onRest = void 0;
            }
          } else {
            each3(BATCHED_EVENTS, function (key) {
              var handler = props[key];
              if (is6.fun(handler)) {
                var queue = ctrl["_events"][key];
                props[key] = function (_ref29) {
                  var finished = _ref29.finished,
                    cancelled = _ref29.cancelled;
                  var result2 = queue.get(handler);
                  if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                  } else {
                    queue.set(handler, {
                      value: null,
                      finished: finished || false,
                      cancelled: cancelled || false
                    });
                  }
                };
                if (defaults2) {
                  defaults2[key] = props[key];
                }
              }
            });
          }
          state = ctrl["_state"];
          if (props.pause === !state.paused) {
            state.paused = props.pause;
            flushCalls2(props.pause ? state.pauseQueue : state.resumeQueue);
          } else if (state.paused) {
            props.pause = true;
          }
          promises = (keys || Object.keys(ctrl.springs)).map(function (key) {
            return ctrl.springs[key].start(props);
          });
          cancel = props.cancel === true || getDefaultProp(props, "cancel") === true;
          if (asyncTo || cancel && state.asyncId) {
            promises.push(scheduleProps(++ctrl["_lastAsyncId"], {
              props: props,
              state: state,
              actions: {
                pause: noop,
                resume: noop,
                start: function start(props2, resolve) {
                  if (cancel) {
                    stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve(getCancelledResult(ctrl));
                  } else {
                    props2.onRest = onRest;
                    resolve(runAsync(asyncTo, props2, state, ctrl));
                  }
                }
              }
            }));
          }
          if (!state.paused) {
            _context4.next = 15;
            break;
          }
          _context4.next = 15;
          return new Promise(function (resume) {
            state.resumeQueue.add(resume);
          });
        case 15:
          _context4.t0 = getCombinedResult;
          _context4.t1 = ctrl;
          _context4.next = 19;
          return Promise.all(promises);
        case 19:
          _context4.t2 = _context4.sent;
          result = (0, _context4.t0)(_context4.t1, _context4.t2);
          if (!(loop && result.finished && !(isLoop && result.noop))) {
            _context4.next = 26;
            break;
          }
          nextProps = createLoopUpdate(props, loop, to2);
          if (!nextProps) {
            _context4.next = 26;
            break;
          }
          prepareKeys(ctrl, [nextProps]);
          return _context4.abrupt("return", flushUpdate(ctrl, nextProps, true));
        case 26:
          if (onResolve) {
            raf4.batchedUpdates(function () {
              return onResolve(result, ctrl, ctrl.item);
            });
          }
          return _context4.abrupt("return", result);
        case 28:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _flushUpdate.apply(this, arguments);
}
function getSprings(ctrl, props) {
  var springs = _objectSpread({}, ctrl.springs);
  if (props) {
    each3(toArray3(props), function (props2) {
      if (is6.und(props2.keys)) {
        props2 = createUpdate(props2);
      }
      if (!is6.obj(props2.to)) {
        props2 = _objectSpread(_objectSpread({}, props2), {}, {
          to: void 0
        });
      }
      prepareSprings(springs, props2, function (key) {
        return createSpring(key);
      });
    });
  }
  setSprings(ctrl, springs);
  return springs;
}
function setSprings(ctrl, springs) {
  eachProp4(springs, function (spring, key) {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      addFluidObserver2(spring, ctrl);
    }
  });
}
function createSpring(key, observer) {
  var spring = new SpringValue();
  spring.key = key;
  if (observer) {
    addFluidObserver2(spring, observer);
  }
  return spring;
}
function prepareSprings(springs, props, create) {
  if (props.keys) {
    each3(props.keys, function (key) {
      var spring = springs[key] || (springs[key] = create(key));
      spring["_prepareNode"](props);
    });
  }
}
function prepareKeys(ctrl, queue) {
  each3(queue, function (props) {
    prepareSprings(ctrl.springs, props, function (key) {
      return createSpring(key, ctrl);
    });
  });
}

// src/SpringContext.tsx
import * as React from "react";
import { useContext } from "react";
import { useMemoOne } from "@react-spring/shared";
var SpringContext = function SpringContext(_ref14) {
  var children = _ref14.children,
    props = _objectWithoutProperties(_ref14, _excluded);
  var inherited = useContext(ctx);
  var pause = props.pause || !!inherited.pause,
    immediate = props.immediate || !!inherited.immediate;
  props = useMemoOne(function () {
    return {
      pause: pause,
      immediate: immediate
    };
  }, [pause, immediate]);
  var Provider = ctx.Provider;
  return /* @__PURE__ */React.createElement(Provider, {
    value: props
  }, children);
};
var ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;
function makeContext(target, init) {
  Object.assign(target, /*#__PURE__*/React.createContext(init));
  target.Provider._context = target;
  target.Consumer._context = target;
  return target;
}

// src/SpringRef.ts
import { each as each4, is as is7, deprecateDirectCall } from "@react-spring/shared";
var SpringRef = function SpringRef() {
  var current = [];
  var SpringRef2 = function SpringRef2(props) {
    deprecateDirectCall();
    var results = [];
    each4(current, function (ctrl, i) {
      if (is7.und(props)) {
        results.push(ctrl.start());
      } else {
        var update2 = _getProps(props, ctrl, i);
        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };
  SpringRef2.current = current;
  SpringRef2.add = function (ctrl) {
    if (!current.includes(ctrl)) {
      current.push(ctrl);
    }
  };
  SpringRef2.delete = function (ctrl) {
    var i = current.indexOf(ctrl);
    if (~i) current.splice(i, 1);
  };
  SpringRef2.pause = function () {
    var _arguments = arguments;
    each4(current, function (ctrl) {
      return ctrl.pause.apply(ctrl, _toConsumableArray(_arguments));
    });
    return this;
  };
  SpringRef2.resume = function () {
    var _arguments2 = arguments;
    each4(current, function (ctrl) {
      return ctrl.resume.apply(ctrl, _toConsumableArray(_arguments2));
    });
    return this;
  };
  SpringRef2.set = function (values) {
    each4(current, function (ctrl, i) {
      var update2 = is7.fun(values) ? values(i, ctrl) : values;
      if (update2) {
        ctrl.set(update2);
      }
    });
  };
  SpringRef2.start = function (props) {
    var _this12 = this;
    var results = [];
    each4(current, function (ctrl, i) {
      if (is7.und(props)) {
        results.push(ctrl.start());
      } else {
        var update2 = _this12._getProps(props, ctrl, i);
        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };
  SpringRef2.stop = function () {
    var _arguments3 = arguments;
    each4(current, function (ctrl) {
      return ctrl.stop.apply(ctrl, _toConsumableArray(_arguments3));
    });
    return this;
  };
  SpringRef2.update = function (props) {
    var _this13 = this;
    each4(current, function (ctrl, i) {
      return ctrl.update(_this13._getProps(props, ctrl, i));
    });
    return this;
  };
  var _getProps = function _getProps(arg, ctrl, index) {
    return is7.fun(arg) ? arg(index, ctrl) : arg;
  };
  SpringRef2._getProps = _getProps;
  return SpringRef2;
};

// src/hooks/useSprings.ts
function useSprings(length, props, deps) {
  var _arguments4 = arguments;
  var propsFn = is8.fun(props) && props;
  if (propsFn && !deps) deps = [];
  var ref = useMemo(function () {
    return propsFn || _arguments4.length == 3 ? SpringRef() : void 0;
  }, []);
  var layoutId = useRef(0);
  var forceUpdate = useForceUpdate();
  var state = useMemo(function () {
    return {
      ctrls: [],
      queue: [],
      flush: function flush(ctrl, updates2) {
        var springs2 = getSprings(ctrl, updates2);
        var canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some(function (key) {
          return !ctrl.springs[key];
        });
        return canFlushSync ? flushUpdateQueue(ctrl, updates2) : new Promise(function (resolve) {
          setSprings(ctrl, springs2);
          state.queue.push(function () {
            resolve(flushUpdateQueue(ctrl, updates2));
          });
          forceUpdate();
        });
      }
    };
  }, []);
  var ctrls = useRef(_toConsumableArray(state.ctrls));
  var updates = [];
  var prevLength = usePrev(length) || 0;
  useMemo(function () {
    each5(ctrls.current.slice(length, prevLength), function (ctrl) {
      detachRefs(ctrl, ref);
      ctrl.stop(true);
    });
    ctrls.current.length = length;
    declareUpdates(prevLength, length);
  }, [length]);
  useMemo(function () {
    declareUpdates(0, Math.min(prevLength, length));
  }, deps);
  function declareUpdates(startIndex, endIndex) {
    for (var i = startIndex; i < endIndex; i++) {
      var ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller(null, state.flush));
      var update2 = propsFn ? propsFn(i, ctrl) : props[i];
      if (update2) {
        updates[i] = declareUpdate(update2);
      }
    }
  }
  var springs = ctrls.current.map(function (ctrl, i) {
    return getSprings(ctrl, updates[i]);
  });
  var context = useContext2(SpringContext);
  var prevContext = usePrev(context);
  var hasContext = context !== prevContext && hasProps(context);
  useIsomorphicLayoutEffect2(function () {
    layoutId.current++;
    state.ctrls = ctrls.current;
    var queue = state.queue;
    if (queue.length) {
      state.queue = [];
      each5(queue, function (cb) {
        return cb();
      });
    }
    each5(ctrls.current, function (ctrl, i) {
      ref === null || ref === void 0 ? void 0 : ref.add(ctrl);
      if (hasContext) {
        ctrl.start({
          default: context
        });
      }
      var update2 = updates[i];
      if (update2) {
        replaceRef(ctrl, update2.ref);
        if (ctrl.ref) {
          ctrl.queue.push(update2);
        } else {
          ctrl.start(update2);
        }
      }
    });
  });
  useOnce(function () {
    return function () {
      each5(state.ctrls, function (ctrl) {
        return ctrl.stop(true);
      });
    };
  });
  var values = springs.map(function (x) {
    return _objectSpread({}, x);
  });
  return ref ? [values, ref] : values;
}

// src/hooks/useSpring.ts
function useSpring(props, deps) {
  var isFn = is9.fun(props);
  var _useSprings = useSprings(1, isFn ? props : [props], isFn ? deps || [] : deps),
    _useSprings2 = _slicedToArray(_useSprings, 2),
    _useSprings2$ = _slicedToArray(_useSprings2[0], 1),
    values = _useSprings2$[0],
    ref = _useSprings2[1];
  return isFn || arguments.length == 2 ? [values, ref] : values;
}

// src/hooks/useSpringRef.ts
import { useState } from "react";
var initSpringRef = function initSpringRef() {
  return SpringRef();
};
var useSpringRef = function useSpringRef() {
  return useState(initSpringRef)[0];
};

// src/hooks/useSpringValue.ts
import { useConstant, useOnce as useOnce2 } from "@react-spring/shared";
var useSpringValue = function useSpringValue(initial, props) {
  var springValue = useConstant(function () {
    return new SpringValue(initial, props);
  });
  useOnce2(function () {
    return function () {
      springValue.stop();
    };
  });
  return springValue;
};

// src/hooks/useTrail.ts
import { each as each6, is as is10, useIsomorphicLayoutEffect as useIsomorphicLayoutEffect3 } from "@react-spring/shared";
function useTrail(length, propsArg, deps) {
  var propsFn = is10.fun(propsArg) && propsArg;
  if (propsFn && !deps) deps = [];
  var reverse = true;
  var passedRef = void 0;
  var result = useSprings(length, function (i, ctrl) {
    var props = propsFn ? propsFn(i, ctrl) : propsArg;
    passedRef = props.ref;
    reverse = reverse && props.reverse;
    return props;
  },
  // Ensure the props function is called when no deps exist.
  // This works around the 3 argument rule.
  deps || [{}]);
  useIsomorphicLayoutEffect3(function () {
    each6(result[1].current, function (ctrl, i) {
      var parent = result[1].current[i + (reverse ? 1 : -1)];
      replaceRef(ctrl, passedRef);
      if (ctrl.ref) {
        if (parent) {
          ctrl.update({
            to: parent.springs
          });
        }
        return;
      }
      if (parent) {
        ctrl.start({
          to: parent.springs
        });
      } else {
        ctrl.start();
      }
    });
  }, deps);
  if (propsFn || arguments.length == 3) {
    var _passedRef;
    var ref = (_passedRef = passedRef) !== null && _passedRef !== void 0 ? _passedRef : result[1];
    ref["_getProps"] = function (propsArg2, ctrl, i) {
      var props = is10.fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
      if (props) {
        var parent = ref.current[i + (props.reverse ? 1 : -1)];
        if (parent) props.to = parent.springs;
        return props;
      }
    };
    return result;
  }
  return result[0];
}

// src/hooks/useTransition.tsx
import * as React2 from "react";
import { useContext as useContext3, useRef as useRef2, useMemo as useMemo2 } from "react";
import { is as is11, toArray as toArray4, useForceUpdate as useForceUpdate2, useOnce as useOnce3, usePrev as usePrev2, each as each7, useIsomorphicLayoutEffect as useIsomorphicLayoutEffect4 } from "@react-spring/shared";
function useTransition(data, props, deps) {
  var _arguments5 = arguments;
  var propsFn = is11.fun(props) && props;
  var _ref15 = propsFn ? propsFn() : props,
    reset = _ref15.reset,
    sort = _ref15.sort,
    _ref15$trail = _ref15.trail,
    trail = _ref15$trail === void 0 ? 0 : _ref15$trail,
    _ref15$expires = _ref15.expires,
    expires = _ref15$expires === void 0 ? true : _ref15$expires,
    _ref15$exitBeforeEnte = _ref15.exitBeforeEnter,
    exitBeforeEnter = _ref15$exitBeforeEnte === void 0 ? false : _ref15$exitBeforeEnte,
    onDestroyed = _ref15.onDestroyed,
    propsRef = _ref15.ref,
    propsConfig = _ref15.config;
  var ref = useMemo2(function () {
    return propsFn || _arguments5.length == 3 ? SpringRef() : void 0;
  }, []);
  var items = toArray4(data);
  var transitions = [];
  var usedTransitions = useRef2(null);
  var prevTransitions = reset ? null : usedTransitions.current;
  useIsomorphicLayoutEffect4(function () {
    usedTransitions.current = transitions;
  });
  useOnce3(function () {
    each7(transitions, function (t) {
      ref === null || ref === void 0 ? void 0 : ref.add(t.ctrl);
      t.ctrl.ref = ref;
    });
    return function () {
      each7(usedTransitions.current, function (t) {
        if (t.expired) {
          clearTimeout(t.expirationId);
        }
        detachRefs(t.ctrl, ref);
        t.ctrl.stop(true);
      });
    };
  });
  var keys = getKeys(items, propsFn ? propsFn() : props, prevTransitions);
  var expired = reset && usedTransitions.current || [];
  useIsomorphicLayoutEffect4(function () {
    return each7(expired, function (_ref16) {
      var ctrl = _ref16.ctrl,
        item = _ref16.item,
        key = _ref16.key;
      detachRefs(ctrl, ref);
      callProp(onDestroyed, item, key);
    });
  });
  var reused = [];
  if (prevTransitions) each7(prevTransitions, function (t, i) {
    if (t.expired) {
      clearTimeout(t.expirationId);
      expired.push(t);
    } else {
      i = reused[i] = keys.indexOf(t.key);
      if (~i) transitions[i] = t;
    }
  });
  each7(items, function (item, i) {
    if (!transitions[i]) {
      transitions[i] = {
        key: keys[i],
        item: item,
        phase: "mount" /* MOUNT */,
        ctrl: new Controller()
      };
      transitions[i].ctrl.item = item;
    }
  });
  if (reused.length) {
    var i = -1;
    var _ref17 = propsFn ? propsFn() : props,
      leave = _ref17.leave;
    each7(reused, function (keyIndex, prevIndex) {
      var t = prevTransitions[prevIndex];
      if (~keyIndex) {
        i = transitions.indexOf(t);
        transitions[i] = _objectSpread(_objectSpread({}, t), {}, {
          item: items[keyIndex]
        });
      } else if (leave) {
        transitions.splice(++i, 0, t);
      }
    });
  }
  if (is11.fun(sort)) {
    transitions.sort(function (a, b) {
      return sort(a.item, b.item);
    });
  }
  var delay = -trail;
  var forceUpdate = useForceUpdate2();
  var defaultProps = getDefaultProps(props);
  var changes = /* @__PURE__ */new Map();
  var exitingTransitions = useRef2( /* @__PURE__ */new Map());
  var forceChange = useRef2(false);
  each7(transitions, function (t, i) {
    var key = t.key;
    var prevPhase = t.phase;
    var p = propsFn ? propsFn() : props;
    var to2;
    var phase;
    var propsDelay = callProp(p.delay || 0, key);
    if (prevPhase == "mount" /* MOUNT */) {
      to2 = p.enter;
      phase = "enter" /* ENTER */;
    } else {
      var isLeave = keys.indexOf(key) < 0;
      if (prevPhase != "leave" /* LEAVE */) {
        if (isLeave) {
          to2 = p.leave;
          phase = "leave" /* LEAVE */;
        } else if (to2 = p.update) {
          phase = "update" /* UPDATE */;
        } else return;
      } else if (!isLeave) {
        to2 = p.enter;
        phase = "enter" /* ENTER */;
      } else return;
    }
    to2 = callProp(to2, t.item, i);
    to2 = is11.obj(to2) ? inferTo(to2) : {
      to: to2
    };
    if (!to2.config) {
      var config2 = propsConfig || defaultProps.config;
      to2.config = callProp(config2, t.item, i, phase);
    }
    delay += trail;
    var payload = _objectSpread(_objectSpread({}, defaultProps), {}, {
      // we need to add our props.delay value you here.
      delay: propsDelay + delay,
      ref: propsRef,
      immediate: p.immediate,
      // This prevents implied resets.
      reset: false
    }, to2);
    if (phase == "enter" /* ENTER */ && is11.und(payload.from)) {
      var p2 = propsFn ? propsFn() : props;
      var from = is11.und(p2.initial) || prevTransitions ? p2.from : p2.initial;
      payload.from = callProp(from, t.item, i);
    }
    var onResolve = payload.onResolve;
    payload.onResolve = function (result) {
      callProp(onResolve, result);
      var transitions2 = usedTransitions.current;
      var t2 = transitions2.find(function (t3) {
        return t3.key === key;
      });
      if (!t2) return;
      if (result.cancelled && t2.phase != "update" /* UPDATE */) {
        return;
      }
      if (t2.ctrl.idle) {
        var idle = transitions2.every(function (t3) {
          return t3.ctrl.idle;
        });
        if (t2.phase == "leave" /* LEAVE */) {
          var expiry = callProp(expires, t2.item);
          if (expiry !== false) {
            var expiryMs = expiry === true ? 0 : expiry;
            t2.expired = true;
            if (!idle && expiryMs > 0) {
              if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
              return;
            }
          }
        }
        if (idle && transitions2.some(function (t3) {
          return t3.expired;
        })) {
          exitingTransitions.current.delete(t2);
          if (exitBeforeEnter) {
            forceChange.current = true;
          }
          forceUpdate();
        }
      }
    };
    var springs = getSprings(t.ctrl, payload);
    if (phase === "leave" /* LEAVE */ && exitBeforeEnter) {
      exitingTransitions.current.set(t, {
        phase: phase,
        springs: springs,
        payload: payload
      });
    } else {
      changes.set(t, {
        phase: phase,
        springs: springs,
        payload: payload
      });
    }
  });
  var context = useContext3(SpringContext);
  var prevContext = usePrev2(context);
  var hasContext = context !== prevContext && hasProps(context);
  useIsomorphicLayoutEffect4(function () {
    if (hasContext) {
      each7(transitions, function (t) {
        t.ctrl.start({
          default: context
        });
      });
    }
  }, [context]);
  each7(changes, function (_, t) {
    if (exitingTransitions.current.size) {
      var ind = transitions.findIndex(function (state) {
        return state.key === t.key;
      });
      transitions.splice(ind, 1);
    }
  });
  useIsomorphicLayoutEffect4(function () {
    each7(exitingTransitions.current.size ? exitingTransitions.current : changes, function (_ref18, t) {
      var phase = _ref18.phase,
        payload = _ref18.payload;
      var ctrl = t.ctrl;
      t.phase = phase;
      ref === null || ref === void 0 ? void 0 : ref.add(ctrl);
      if (hasContext && phase == "enter" /* ENTER */) {
        ctrl.start({
          default: context
        });
      }
      if (payload) {
        replaceRef(ctrl, payload.ref);
        if ((ctrl.ref || ref) && !forceChange.current) {
          ctrl.update(payload);
        } else {
          ctrl.start(payload);
          if (forceChange.current) {
            forceChange.current = false;
          }
        }
      }
    });
  }, reset ? void 0 : deps);
  var renderTransitions = function renderTransitions(render) {
    return /* @__PURE__ */React2.createElement(React2.Fragment, null, transitions.map(function (t, i) {
      var _ref19 = changes.get(t) || t.ctrl,
        springs = _ref19.springs;
      var elem = render(_objectSpread({}, springs), t.item, t, i);
      return elem && elem.type ? /* @__PURE__ */React2.createElement(elem.type, _objectSpread(_objectSpread({}, elem.props), {}, {
        key: is11.str(t.key) || is11.num(t.key) ? t.key : t.ctrl.id,
        ref: elem.ref
      })) : elem;
    }));
  };
  return ref ? [renderTransitions, ref] : renderTransitions;
}
var nextKey = 1;
function getKeys(items, _ref20, prevTransitions) {
  var key = _ref20.key,
    _ref20$keys = _ref20.keys,
    keys = _ref20$keys === void 0 ? key : _ref20$keys;
  if (keys === null) {
    var reused = /* @__PURE__ */new Set();
    return items.map(function (item) {
      var t = prevTransitions && prevTransitions.find(function (t2) {
        return t2.item === item && t2.phase !== "leave" /* LEAVE */ && !reused.has(t2);
      });
      if (t) {
        reused.add(t);
        return t.key;
      }
      return nextKey++;
    });
  }
  return is11.und(keys) ? items : is11.fun(keys) ? items.map(keys) : toArray4(keys);
}

// src/hooks/useScroll.ts
import { each as each8, onScroll, useIsomorphicLayoutEffect as useIsomorphicLayoutEffect5 } from "@react-spring/shared";
var useScroll = function useScroll() {
  var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    container = _ref21.container,
    springOptions = _objectWithoutProperties(_ref21, _excluded2);
  var _useSpring = useSpring(function () {
      return _objectSpread({
        scrollX: 0,
        scrollY: 0,
        scrollXProgress: 0,
        scrollYProgress: 0
      }, springOptions);
    }, []),
    _useSpring2 = _slicedToArray(_useSpring, 2),
    scrollValues = _useSpring2[0],
    api = _useSpring2[1];
  useIsomorphicLayoutEffect5(function () {
    var cleanupScroll = onScroll(function (_ref22) {
      var x = _ref22.x,
        y = _ref22.y;
      api.start({
        scrollX: x.current,
        scrollXProgress: x.progress,
        scrollY: y.current,
        scrollYProgress: y.progress
      });
    }, {
      container: (container === null || container === void 0 ? void 0 : container.current) || void 0
    });
    return function () {
      each8(Object.values(scrollValues), function (value) {
        return value.stop();
      });
      cleanupScroll();
    };
  }, []);
  return scrollValues;
};

// src/hooks/useResize.ts
import { onResize, each as each9, useIsomorphicLayoutEffect as useIsomorphicLayoutEffect6 } from "@react-spring/shared";
var useResize = function useResize(_ref23) {
  var container = _ref23.container,
    springOptions = _objectWithoutProperties(_ref23, _excluded3);
  var _useSpring3 = useSpring(function () {
      return _objectSpread({
        width: 0,
        height: 0
      }, springOptions);
    }, []),
    _useSpring4 = _slicedToArray(_useSpring3, 2),
    sizeValues = _useSpring4[0],
    api = _useSpring4[1];
  useIsomorphicLayoutEffect6(function () {
    var cleanupScroll = onResize(function (_ref24) {
      var width = _ref24.width,
        height = _ref24.height;
      api.start({
        width: width,
        height: height,
        immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
      });
    }, {
      container: (container === null || container === void 0 ? void 0 : container.current) || void 0
    });
    return function () {
      each9(Object.values(sizeValues), function (value) {
        return value.stop();
      });
      cleanupScroll();
    };
  }, []);
  return sizeValues;
};

// src/hooks/useInView.ts
import { useRef as useRef3, useState as useState2 } from "react";
import { is as is12, useIsomorphicLayoutEffect as useIsomorphicLayoutEffect7 } from "@react-spring/shared";
var defaultThresholdOptions = {
  any: 0,
  all: 1
};
function useInView(props, args) {
  var _useState = useState2(false),
    _useState2 = _slicedToArray(_useState, 2),
    isInView = _useState2[0],
    setIsInView = _useState2[1];
  var ref = useRef3();
  var propsFn = is12.fun(props) && props;
  var springsProps = propsFn ? propsFn() : {};
  var _springsProps$to = springsProps.to,
    to2 = _springsProps$to === void 0 ? {} : _springsProps$to,
    _springsProps$from = springsProps.from,
    from = _springsProps$from === void 0 ? {} : _springsProps$from,
    restSpringProps = _objectWithoutProperties(springsProps, _excluded4);
  var intersectionArguments = propsFn ? args : props;
  var _useSpring5 = useSpring(function () {
      return _objectSpread({
        from: from
      }, restSpringProps);
    }, []),
    _useSpring6 = _slicedToArray(_useSpring5, 2),
    springs = _useSpring6[0],
    api = _useSpring6[1];
  useIsomorphicLayoutEffect7(function () {
    var element = ref.current;
    var _ref25 = intersectionArguments !== null && intersectionArguments !== void 0 ? intersectionArguments : {},
      root = _ref25.root,
      once = _ref25.once,
      _ref25$amount = _ref25.amount,
      amount = _ref25$amount === void 0 ? "any" : _ref25$amount,
      restArgs = _objectWithoutProperties(_ref25, _excluded5);
    if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
    var activeIntersections = /* @__PURE__ */new WeakMap();
    var onEnter = function onEnter() {
      if (to2) {
        api.start(to2);
      }
      setIsInView(true);
      var cleanup = function cleanup() {
        if (from) {
          api.start(from);
        }
        setIsInView(false);
      };
      return once ? void 0 : cleanup;
    };
    var handleIntersection = function handleIntersection(entries) {
      entries.forEach(function (entry) {
        var onLeave = activeIntersections.get(entry.target);
        if (entry.isIntersecting === Boolean(onLeave)) {
          return;
        }
        if (entry.isIntersecting) {
          var newOnLeave = onEnter();
          if (is12.fun(newOnLeave)) {
            activeIntersections.set(entry.target, newOnLeave);
          } else {
            observer.unobserve(entry.target);
          }
        } else if (onLeave) {
          onLeave();
          activeIntersections.delete(entry.target);
        }
      });
    };
    var observer = new IntersectionObserver(handleIntersection, _objectSpread({
      root: root && root.current || void 0,
      threshold: typeof amount === "number" || Array.isArray(amount) ? amount : defaultThresholdOptions[amount]
    }, restArgs));
    observer.observe(element);
    return function () {
      return observer.unobserve(element);
    };
  }, [intersectionArguments]);
  if (propsFn) {
    return [ref, springs];
  }
  return [ref, isInView];
}

// src/components/Spring.tsx
function Spring(_ref26) {
  var children = _ref26.children,
    props = _objectWithoutProperties(_ref26, _excluded6);
  return children(useSpring(props));
}

// src/components/Trail.tsx
import { is as is13 } from "@react-spring/shared";
function Trail(_ref27) {
  var items = _ref27.items,
    children = _ref27.children,
    props = _objectWithoutProperties(_ref27, _excluded7);
  var trails = useTrail(items.length, props);
  return items.map(function (item, index) {
    var result = children(item, index);
    return is13.fun(result) ? result(trails[index]) : result;
  });
}

// src/components/Transition.tsx
function Transition(_ref28) {
  var items = _ref28.items,
    children = _ref28.children,
    props = _objectWithoutProperties(_ref28, _excluded8);
  return useTransition(items, props)(children);
}

// src/interpolate.ts
import { deprecateInterpolate as deprecateInterpolate2 } from "@react-spring/shared";

// src/Interpolation.ts
import { is as is14, raf as raf5, each as each10, isEqual as isEqual2, toArray as toArray5, frameLoop as frameLoop3, getFluidValue as getFluidValue3, createInterpolator, Globals as G6, callFluidObservers as callFluidObservers3, addFluidObserver as addFluidObserver3, removeFluidObserver as removeFluidObserver2, hasFluidValue as hasFluidValue2 } from "@react-spring/shared";
import { getAnimated as getAnimated3, setAnimated as setAnimated2, getAnimatedType as getAnimatedType2, getPayload as getPayload2 } from "@react-spring/animated";
var Interpolation = /*#__PURE__*/function (_FrameValue2) {
  _inherits(Interpolation, _FrameValue2);
  var _super5 = _createSuper(Interpolation);
  function Interpolation(source, args) {
    var _this14;
    _classCallCheck(this, Interpolation);
    _this14 = _super5.call(this);
    _this14.source = source;
    /** Equals false when in the frameloop */
    _this14.idle = true;
    /** The inputs which are currently animating */
    _this14._active = /* @__PURE__ */new Set();
    _this14.calc = createInterpolator.apply(void 0, _toConsumableArray(args));
    var value = _this14._get();
    var nodeType = getAnimatedType2(value);
    setAnimated2(_assertThisInitialized(_this14), nodeType.create(value));
    return _this14;
  }
  _createClass(Interpolation, [{
    key: "advance",
    value: function advance(_dt) {
      var value = this._get();
      var oldValue = this.get();
      if (!isEqual2(value, oldValue)) {
        getAnimated3(this).setValue(value);
        this._onChange(value, this.idle);
      }
      if (!this.idle && checkIdle(this._active)) {
        becomeIdle(this);
      }
    }
  }, {
    key: "_get",
    value: function _get() {
      var inputs = is14.arr(this.source) ? this.source.map(getFluidValue3) : toArray5(getFluidValue3(this.source));
      return this.calc.apply(this, _toConsumableArray(inputs));
    }
  }, {
    key: "_start",
    value: function _start() {
      var _this15 = this;
      if (this.idle && !checkIdle(this._active)) {
        this.idle = false;
        each10(getPayload2(this), function (node) {
          node.done = false;
        });
        if (G6.skipAnimation) {
          raf5.batchedUpdates(function () {
            return _this15.advance();
          });
          becomeIdle(this);
        } else {
          frameLoop3.start(this);
        }
      }
    }
    // Observe our sources only when we're observed.
  }, {
    key: "_attach",
    value: function _attach() {
      var _this16 = this;
      var priority = 1;
      each10(toArray5(this.source), function (source) {
        if (hasFluidValue2(source)) {
          addFluidObserver3(source, _this16);
        }
        if (isFrameValue(source)) {
          if (!source.idle) {
            _this16._active.add(source);
          }
          priority = Math.max(priority, source.priority + 1);
        }
      });
      this.priority = priority;
      this._start();
    }
    // Stop observing our sources once we have no observers.
  }, {
    key: "_detach",
    value: function _detach() {
      var _this17 = this;
      each10(toArray5(this.source), function (source) {
        if (hasFluidValue2(source)) {
          removeFluidObserver2(source, _this17);
        }
      });
      this._active.clear();
      becomeIdle(this);
    }
    /** @internal */
  }, {
    key: "eventObserved",
    value: function eventObserved(event) {
      if (event.type == "change") {
        if (event.idle) {
          this.advance();
        } else {
          this._active.add(event.parent);
          this._start();
        }
      } else if (event.type == "idle") {
        this._active.delete(event.parent);
      } else if (event.type == "priority") {
        this.priority = toArray5(this.source).reduce(function (highest, parent) {
          return Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1);
        }, 0);
      }
    }
  }]);
  return Interpolation;
}(FrameValue);
function isIdle(source) {
  return source.idle !== false;
}
function checkIdle(active) {
  return !active.size || Array.from(active).every(isIdle);
}
function becomeIdle(self) {
  if (!self.idle) {
    self.idle = true;
    each10(getPayload2(self), function (node) {
      node.done = true;
    });
    callFluidObservers3(self, {
      type: "idle",
      parent: self
    });
  }
}

// src/interpolate.ts
var to = function to(source) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }
  return new Interpolation(source, args);
};
var interpolate = function interpolate(source) {
  for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    args[_key6 - 1] = arguments[_key6];
  }
  return deprecateInterpolate2(), new Interpolation(source, args);
};

// src/globals.ts
import { Globals, frameLoop as frameLoop4, createStringInterpolator } from "@react-spring/shared";
Globals.assign({
  createStringInterpolator: createStringInterpolator,
  to: function to(source, args) {
    return new Interpolation(source, args);
  }
});
var update = frameLoop4.advance;

// src/index.ts
import { createInterpolator as createInterpolator2, useIsomorphicLayoutEffect as useIsomorphicLayoutEffect8, useReducedMotion, easings as easings2 } from "@react-spring/shared";
export * from "@react-spring/types";
export { BailSignal, Controller, FrameValue, Globals, Interpolation, Spring, SpringContext, SpringRef, SpringValue, Trail, Transition, config, createInterpolator2 as createInterpolator, easings2 as easings, inferTo, interpolate, to, update, useChain, useInView, useIsomorphicLayoutEffect8 as useIsomorphicLayoutEffect, useReducedMotion, useResize, useScroll, useSpring, useSpringRef, useSpringValue, useSprings, useTrail, useTransition };